import { __assign, __rest } from "tslib";
import React from 'react';
import { RouteProvider } from './RouteProvider';
var withRouter = function (Page, routeInfo, useNativeMethods) {
    if (useNativeMethods === void 0) { useNativeMethods = false; }
    return function (pageProps) {
        var ctx = pageProps.ctx, props = __rest(pageProps, ["ctx"]);
        return (React.createElement(RouteProvider, { routeInfo: routeInfo, ctx: ctx, useNativeMethods: useNativeMethods },
            React.createElement(Page, __assign({}, props))));
    };
};
export default withRouter;
//# sourceMappingURL=withRouter.js.map